import React from 'react';
import SearchLogsSummary from '../SearchLogsSummary';

interface SearchProgressLogsProps {
  logs: string[];
  isExpanded: boolean;
  onToggle: () => void;
  maxHeight?: string;
  creatorFilterStats?: any; // For Full Hashtag Search
  searchType?: string;
  keyword?: string; // Added to pass keyword to SearchLogsSummary
}

const SearchProgressLogs: React.FC<SearchProgressLogsProps> = ({
  logs,
  isExpanded,
  onToggle,
  maxHeight = '200px',
  creatorFilterStats,
  searchType,
  keyword = ''
}) => {
  if (!logs || logs.length === 0) return null;

  return (
    <div style={{ marginTop: '16px' }}>
      <button
        onClick={onToggle}
        style={{
          background: 'none',
          border: 'none',
          padding: '4px 8px',
          fontSize: '14px',
          color: '#3b82f6',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          transition: 'color 0.2s'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.color = '#2563eb';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.color = '#3b82f6';
        }}
      >
        <span style={{
          display: 'inline-block',
          transition: 'transform 0.2s',
          transform: isExpanded ? 'rotate(90deg)' : 'rotate(0deg)'
        }}>
          ▶
        </span>
        Search Progress Summary
      </button>

      {isExpanded && (
        <div style={{
          marginTop: '8px'
        }}>
          <SearchLogsSummary
            logs={logs}
            showRawLogs={false}
            creatorFilterStats={creatorFilterStats}
            searchType={searchType}
            keyword={keyword}
          />
        </div>
      )}
    </div>
  );
};

export default SearchProgressLogs;